export const API_URL = "https://plesh-remote-multi-user-api-y2qbyk5t3a-ew.a.run.app/"
//export const API_URL = "http://localhost:8080/"
//export const TOOLPRESS_API = "https://api-tool-press-yn26wrnl4q-ey.a.run.app"
export const TOOLPRESS_API = "https://toolpress-api.2ndstage.app"

export const THEME_CONFIG = {
    mode:"dark",
    gradients: {
        default: ['#e9532f', '#e9532f'],
        home_question: ['#e9532f', '#e9532f'],
    },
    borders : {
        default: 'none',
        home_question: 'none'
    },
    borderRadius: {
        default: '4px',
        photo: '8px',
        textField: '0rem !important',
    },
    shadows : {
        default: 'none',
        home_question: 'none'
    },

    agendaStyle : {
        headerColor: '#e9532f',
        boxShadow: '0px 8px 10px 0px rgba(0,0,0,0.2)',
        borderRadius: '0px',
        headerTextColor: '#fff',
        contentTextColor: '#fff',
        iconColor: '#fff',
        backgroundColor: '#2e1344',
    },

    agendaViewStyle : {
        todayHeaderBkgColor: '#e9532f',
        headerBkgColor: '#1c0b28',
        todayTitleColor: '#fff',
        titleColor: '#fff',
        timesColor: '#fff',
        textColor: '#fff',
        accordionBkgColor: '#2e1344'
    },

    primary: '#fff',
    secondary: '#263238',
    accent: '#e9532f',
    text: '#fff',
    buttonText: {
        home_question: '#fff',
        default: '#fff'
    },
    background:'linear-gradient(180deg, #170609 50%, #531B1C)',

    homeQuestionIcon: false,

    poll:{
        default:"#ffffff",
        answered:"#e9532f",
        correct: '#269d1a',
        wrong: '#6e1514'
    },
    pollBorder: {
        default:"#ffffff",
        answered:"#e9532f",
        correct: '#269d1a',
        wrong: '#6e1514'
    },
    pollTextColor: {
        default:"#000",
        answered:"#fff",
        correct: '#fff',
        wrong: '#fff'
    }
}